module.exports = __webpack_public_path__ + "static/assets/430fec58404987993c5037925ee62c98.png";